import axios, { AxiosInstance } from 'axios'

const api: AxiosInstance = axios.create({
  baseURL: 'https://er-contributions.ru/api',
  headers: {
    'Content-Type': 'application/json',
    Authorization: `${localStorage.getItem('token')}`
  }
})

const participantApiV1: AxiosInstance = axios.create({
  // baseURL: 'http://localhost:8083/api/v1',
  baseURL: 'https://v2.er-contributions.ru/api/v1',
  headers: {
    'Content-Type': 'application/json',
    Authorization: `${localStorage.getItem('token')}`
  }
})

export { api, participantApiV1 }
